export default __webpack_public_path__ + "static/media/猫.9787d164.png";